module.exports = __webpack_public_path__ + "static/media/26UNRWA17.1a9ffe96.jpg";